import { Spin, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import TableActionButton from '../../ui/TableActionButton';
import Title from '../../ui/Title';
import { useDispatch, useSelector } from 'react-redux';
import { deleteIssuer, fetchIssuers } from '../../../store/slices/issuer-slice';
import { Link, useNavigate } from 'react-router-dom';
import ConfirmDialog from '../../ui/ConfirmDialog';
import TightWrapper from '../../ui/TightWrapper';
import LoadingError from '../../ui/error/LoadingError';

const IssuerTable = () => {
    const dispatch = useDispatch();
    const { isLoading, data, isError } = useSelector((state) => state.issuer);
    const [dataSource, setDataSource] = useState([]);

    let nullColumns = [];
    if(dataSource.length) {
      nullColumns = Object.keys(dataSource[0]).filter(key => dataSource.every(item => item[key] === null))
    }

    useEffect(() => {
      dispatch(fetchIssuers());
    }, []);
    
    useEffect(() => {
      if(data.length > 0) {
        setDataSource(
          data.map((item) => ({
            ...item,
            key: item.issuer_id,
            edit_id: item.issuer_id,
            delete_id: item.issuer_id,
          }))
          );
        }
      }, [data]);
      
      const columns = [
        {
          title: 'Issuer Name',
          dataIndex: 'issuer_name',
          key: 'issuer_name',
        },
        {
          title: 'Issuer Short Name',
          dataIndex: 'issuer_short_name',
          key: 'issuer_short_name',
        },
        {
          title: 'Issuer Date',
          dataIndex: 'issuer_date',
          key: 'issuer_date',
          render: (_, { issuer_date }) => issuer_date && issuer_date.split(' ')[0]
        },
        {
          title: 'Edit',
          dataIndex: 'edit_id',
          key: 'edit_id',
          render: (_, {edit_id}) => (
            <TightWrapper>
              <Link to={`/dashboard/issuer-form?mode=EDIT&id=${edit_id}`}>
                <TableActionButton bg='#10ac84'>Edit</TableActionButton>
              </Link>
            </TightWrapper>
          )
        },
        {
          title: 'Delete',
          dataIndex: 'delete_id',
          key: 'delete_id',
          render: (_, {delete_id}) => (
            <ConfirmDialog
                onConfirm={() => dispatch(deleteIssuer({ id: delete_id }))}
              >
              <TightWrapper>
                <TableActionButton bg='#ff6b6b' >Delete</TableActionButton>
              </TightWrapper>
            </ConfirmDialog>
          )
        },
      ].filter((item) => !nullColumns.includes(item.key));

    if(isLoading) return (
      <Spin 
          tip="Loading" 
          size="large" 
          className='loading-spiner'
      />
    );
    if(isError) return <LoadingError />;

    return (
        <Wrapper>
          <Title>Issuers</Title>
            <div className='card'>
                <Table 
                dataSource={dataSource}
                bordered
                size='medium'
                columns={columns} 
                style={{
                    marginTop: '10px',
                    padding: 0,
                }}
                />
            </div>
        </Wrapper>
    );
}

export default IssuerTable;

const Wrapper = styled.div`
    width: 95%;
    margin: auto;
    animation: slide-down 300ms ease-out forwards;
    p {
        color: ${({theme}) => theme.colors.primary};
    }
    .ant-table-tbody {
        border: none;
    }
    .ant-table-thead .ant-table-cell {
        background-color:  ${({theme}) => theme.colors.primary};
        color: white;
        border-radius: 0 !important;
    }
    .card {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
`;

